// ============================================================
// HABIT OS — Bibliothek: Skincare
// Innere Skincare · Äußere Routine · Antioxidantien · Schlaf & Haut
// ============================================================

export const LIBRARY_SKINCARE = {
  id: "skincare",
  label: "Skincare",
  icon: "✨",
  subcategories: [

    // ── INNERE SKINCARE ──────────────────────
    {
      id: "skin_inner",
      label: "Innere Skincare",
      icon: "💊",
      habits: [
        {
          id: "hab_collagen",
          label: "Kollagen-Peptide",
          time: "morning",
          icon: "🧴",
          why: "Kollagen ist ein Strukturprotein der Haut. Vitamin C trägt zu einer normalen Kollagenbildung für eine normale Funktion der Haut bei.",
          source: "Proksch et al., Skin Pharmacology and Physiology, 2014 · Bolke et al., Nutrients, 2019",
          dose: "Laut Herstellerangabe, morgens in Kaffee, Smoothie oder Wasser",
        },
        {
          id: "hab_silica",
          label: "Silizium (Bambus-Extrakt)",
          time: "morning",
          icon: "🎋",
          why: "Silizium kommt in Bambus, Hafer und Hirse vor. Für Silizium gibt es keine zugelassenen gesundheitsbezogenen Angaben.",
          source: "Jurkić et al., Nutrition & Metabolism, 2013 · Araújo et al., Archives of Dermatological Research, 2016",
          dose: "Laut Herstellerangabe, morgens mit Mahlzeit",
        },
        {
          id: "hab_astaxanthin",
          label: "Astaxanthin",
          time: "morning",
          icon: "🦐",
          why: "Astaxanthin ist ein roter Farbstoff aus Algen. Es ersetzt keinen Sonnenschutz.",
          source: "Tominaga et al., Acta Biochimica Polonica, 2012 · Davinelli et al., Nutrients, 2018",
          dose: "Laut Herstellerangabe, mit einer fetthaltigen Mahlzeit.",
        },
        {
          id: "hab_hyaluronic_oral",
          label: "Hyaluronsäure (oral)",
          time: "morning",
          icon: "💧",
          why: "Hyaluronsäure ist ein natürlicher Bestandteil der Haut. Für die Einnahme gibt es keine zugelassenen gesundheitsbezogenen Angaben.",
          source: "Kawada et al., Journal of Clinical Biochemistry and Nutrition, 2015 · Oe et al., Nutrition Journal, 2016",
          dose: "Laut Herstellerangabe, morgens",
        },
        {
          id: "hab_vitamin_c_skin",
          label: "Vitamin C",
          time: "morning",
          icon: "🍊",
          why: "Vitamin C trägt zu einer normalen Kollagenbildung für eine normale Funktion der Haut bei und hilft, die Zellen vor oxidativem Stress zu schützen.",
          source: "Pullar et al., Nutrients, 2017 · Carr & Maggini, Nutrients, 2017",
          dose: "Laut Herstellerangabe, mit einer Mahlzeit.",
        },
      ],
    },

    // ── ÄUSSERE ROUTINE ──────────────────────
    {
      id: "skin_outer",
      label: "Äußere Routine",
      icon: "🧴",
      habits: [
        {
          id: "hab_sunscreen",
          label: "SPF 30–50 täglich (auch im Winter)",
          time: "morning",
          icon: "🌞",
          why: "UV-Strahlung ist für bis zu 90% der sichtbaren Hautalterung verantwortlich — mehr als alle anderen Faktoren zusammen. UVA-Strahlen (Alterung, Krebs) durchdringen Wolken und Glas ganzjährig. Täglicher Sonnenschutz ist die am besten belegte Anti-Aging-Intervention überhaupt. Dermatologen bezeichnen ihn als 'das einzige echte Anti-Aging-Produkt'.",
          source: "Hughes et al., Annals of Internal Medicine, 2013 · Skin Cancer Foundation, 2023",
          dose: "SPF 30–50 täglich, letzter Schritt der Morgenroutine — mindestens 1/4 Teelöffel für Gesicht",
        },
        {
          id: "hab_retinol",
          label: "Retinol / Retinal (abends)",
          time: "night",
          icon: "🔬",
          why: "Retinol ist ein Vitamin-A-Abkömmling und ein bewährter Pflegewirkstoff. Es macht die Haut lichtempfindlicher.",
          source: "Mukherjee et al., Clinical Interventions in Aging, 2006 · Zasada & Budzisz, Postepy Dermatologii, 2019",
          dose: "Laut Herstellerangabe abends, langsam steigern und tagsüber Sonnenschutz verwenden. Nicht in Schwangerschaft und Stillzeit.",
        },
        {
          id: "hab_niacinamide",
          label: "Niacinamide (topisch)",
          time: "morning",
          icon: "✨",
          why: "Niacinamid (eine Form von Vitamin B3) ist ein gut verträglicher Pflegewirkstoff, der die Hautbarriere unterstützt und das Hautbild ebenmäßiger wirken lassen kann. Er lässt sich mit den meisten anderen Wirkstoffen kombinieren.",
          source: "Bissett et al., Dermatologic Surgery, 2005 · Levin & Maibach, Dermatologic Surgery, 2005",
          dose: "5–10% Niacinamide, morgens nach dem Reinigen, vor dem Feuchtigkeitsprodukt",
        },
        {
          id: "hab_double_cleanse",
          label: "Double Cleansing abends",
          time: "night",
          icon: "🫧",
          why: "Double Cleansing (Öl-Reiniger, dann wasserlöslicher Reiniger) ist die effektivste Methode zur vollständigen Entfernung von Sonnenschutz, Makeup, Feinstaub und Talg — ohne die Hautbarriere zu kompromittieren. Feinstaub (PM2.5) dringt in Poren ein und produziert freie Radikale die Kollagen abbauen. Unvollständige Reinigung macht alle nachfolgenden Wirkstoffe weniger wirksam.",
          source: "Draelos ZD, Journal of Cosmetic Dermatology, 2006 · Kim et al., Annals of Dermatology, 2016",
          dose: "Schritt 1: Öl- oder Mizellen-Reiniger, Schritt 2: schaumender oder Gel-Reiniger — täglich abends",
        },
        {
          id: "hab_gua_sha",
          label: "Gua Sha / Gesichtsmassage",
          time: "morning",
          icon: "💆",
          why: "Eine sanfte Gesichtsmassage mit Gua-Sha-Stein kann entspannend wirken. Immer mit Öl und leichtem Druck arbeiten.",
          source: "Vigotsky & Bruhns, Pain Medicine, 2015 · Cao et al., Journal of Alternative and Complementary Medicine, 2010",
          dose: "3–5 Min. täglich, morgens nach dem Auftragen von Öl oder Serum — immer nach außen streichen",
        },
      ],
    },

    // ── ANTIOXIDANTIEN FÜR DIE HAUT ─────────
    {
      id: "skin_antioxidants",
      label: "Antioxidantien",
      icon: "🫐",
      habits: [
        {
          id: "hab_polyphenols",
          label: "Polyphenol-reiche Ernährung",
          time: "flexible",
          icon: "🍇",
          why: "Polyphenole stecken in Beeren, grünem Tee, Kakao und vielen anderen Pflanzen. Eine bunte, pflanzenreiche Ernährung ist eine gute Grundlage für das allgemeine Wohlbefinden.",
          source: "Ramos S, Molecular Nutrition & Food Research, 2008 · Nichols & Katiyar, Archives of Dermatological Research, 2010",
          dose: "Täglich: Blaubeeren, dunkle Schokolade (85%+), grüner Tee, Granatapfel, rote Weintrauben",
        },
        {
          id: "hab_green_tea",
          label: "Grüner Tee (3–4 Tassen täglich)",
          time: "flexible",
          icon: "🍵",
          why: "Grüner Tee enthält Polyphenole wie EGCG und ist eine Alternative zu gesüßten Getränken.",
          source: "Katiyar et al., Photochemistry and Photobiology, 2007 · Kim et al., Antioxidants, 2022",
          dose: "3–4 Tassen täglich, bei 70–80°C aufgebrüht (nicht kochend — zerstört EGCG)",
        },
      ],
    },

    // ── SCHLAF & HAUT ────────────────────────
    {
      id: "skin_sleep",
      label: "Schlaf & Haut",
      icon: "😴",
      habits: [
        {
          id: "hab_silk_pillowcase",
          label: "Seidenkissen-Bezug",
          time: "night",
          icon: "🛏️",
          why: "Seidenbezüge sind glatter als Baumwolle und verursachen weniger Reibung an Haut und Haaren.",
          source: "American Academy of Dermatology, Sleep Skin Study, 2016 · Comfort et al., Journal of Dermatology, 2019",
          dose: "Täglich — Seidenbezug mindestens wöchentlich waschen bei 30°C",
        },
        {
          id: "hab_overnight_mask",
          label: "Schlafmaske / Nachtcreme",
          time: "night",
          icon: "🌙",
          why: "Eine reichhaltige Nachtcreme unterstützt die Feuchtigkeit der Haut über Nacht.",
          source: "Yosipovitch & Maibach, Skin Pharmacology and Physiology, 1996 · Plikus et al., Cell, 2017",
          dose: "Letzter Schritt der Abend-Routine, dick auftragen — Ceramide + Peptide als Wirkstoffe bevorzugen",
        },
      ],
    },
  ],
};